declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';

import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { FDActorDocRequest } from '../../../../models/formdesign/fd.model';
import { FDService } from '../../../../services/fd.service';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'actorformsmodal',
  templateUrl: './actorforms.modal.html',
  styleUrls: ['./actorforms.modal.scss']
})

export class NgbActorFormsModal implements OnInit {
  @ViewChild('f') ActorFormsForm: NgForm;

  @Input() ReportType: number;

  CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ActorReportTemplateCode: number = 0;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private fdservice: FDService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService
  ) { }
  ngOnInit() {

    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentFDActorDocRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;

  }



  public onSubmit() {
    if (this.ActorReportTemplateCode > 0) {
      this.StartRefreshing();
      this.CurrentFDActorDocRequest.ConditionalOperator = 1;
      this.CurrentFDActorDocRequest.ActorReportTemplateCode = this.ActorReportTemplateCode;

      this.fdservice.SaveFdActorReportDoc(this.CurrentFDActorDocRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            if (this.ApiResData.Result > 0) {

             // alertFunctions.AlertParam('Saved Successfully.....!');
              this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

              this.activeModal.close();


              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");


              this.stopRefreshing();
              this.activeModal.close();

            }

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
              this.activeModal.close();



            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              this.activeModal.close();
            }
          }

        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
             this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
        );
    }
    else {
      alertFunctions.AlertParam('Please Select Template Properly...!');
    }
  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 




}
